module.exports = __webpack_public_path__ + "static/media/raul-github.7ae69c4d.jpeg";